const rtl_languages = ['ar', 'he'];

export const isLanguageRtl = (code: string) => rtl_languages.includes(code);
